import MuiDrawer from '@mui/material/Drawer';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';

type DrawerProps = ComponentPropsWithoutRef<typeof MuiDrawer>;
type DrawerRef = ComponentRef<typeof MuiDrawer>;

const Drawer = forwardRef<DrawerRef, DrawerProps>((props, ref) => {
  return <MuiDrawer ref={ref} {...props} />;
});

Drawer.displayName = 'Drawer';

export default Drawer;
